const INTERNAL_DOMAIN = "advoc8.co";

function isIgnoredHref(href) {
  return href.startsWith("#") || href.startsWith("javascript:") || href.startsWith("/");
}

function isInternalUrl(href) {
  try {
    const url = new URL(href, window.location.origin);
    // blob: and filesystem: URLs expose an empty host; their real domain lives
    // in the origin (e.g. "blob:https://app.advoc8.co/..." has host "" but
    // origin "https://app.advoc8.co"), so resolve the host from there.
    const host = url.host || new URL(url.origin).host;
    return (
      host === window.location.host ||
      host === INTERNAL_DOMAIN ||
      host.endsWith("." + INTERNAL_DOMAIN)
    );
  } catch (error) {
    return true;
  }
}

$(document).on("click", "a[href]", function () {
  const $link = $(this);
  const href = $link.attr("href");

  if ($link.data("ignore-external-url") !== undefined || !href) { return; }
  if (isIgnoredHref(href) || isInternalUrl(href)) { return; }

  return confirm("Notice: You are being directed to an external site: \n" + href);
});
